import { CHANGE_SCHOOL_TERM_LIST } from '../actions/schoolTermActions';

const initialState = {
  listOfTerms: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CHANGE_SCHOOL_TERM_LIST:
      return {
        ...state,
        listOfTerms: [...action.payload.list],
      };
    default:
      return state;
  }
}
